<template>
  <header :class="['tender-header', isTemplate ? 'print-area' : 'no-print']">
    <bear-actions></bear-actions>
  </header>
</template>
<script>
import BearActions from '../../../actions/src'
import {mapState} from 'vuex'
export default {
  name: 'TenderHeader',
  components: {
    BearActions
  },
  computed: {
    ...mapState(['isTemplate'])
  }
}
</script>
<style lang="scss" scoped>
.tender-header {
  position: sticky;
  z-index: 2;
  top: 0;
  background: #F5F7F9;
  border-bottom: 10px solid #F1F2F7;
}
.tender-header {
  &.print-area {
    display: none;
  }
}
</style>